import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { AssignedButton, AvatarStyled, InfoText } from '../ShiftInformation.styles';
import { selectSelectedShift } from '../../../redux/shifts/shiftsSlice';
import PropTypes from 'prop-types';

/**
 * Button component that displays the current assignment status and triggers employee selection
 *
 * This component serves as both:
 * 1. A display of the current employee assignment status
 * 2. A button that opens the employee selection interface when clicked
 *
 * @param {Object} props
 * @param {Function} props.onAssignClick - Handler that opens the employee selection interface
 */
const EmployeeAssignmentButton = ({ onAssignClick, disabled }) => {
  const shift = useSelector(selectSelectedShift);
  const { employeeInfo } = useSelector((state) => state.currentUser) || {};
  const { id: currentUserId, profileImageUrl: currentUserImage } = employeeInfo || {};
  const isCurrentlyAssigned = !!shift?.assignedName;

  // UI-specific derived state
  const imageToDisplay = shift?.eid === currentUserId ? currentUserImage : shift?.assignedProfileImageUrl;

  return (
    <AssignedButton onClick={disabled ? null : onAssignClick} disabled={disabled}>
      <Box display="flex" alignItems="center">
        <AvatarStyled
          alt={isCurrentlyAssigned ? shift?.assignedName : 'Unassigned'}
          src={isCurrentlyAssigned ? imageToDisplay : ''}
        />
        <Box>
          <InfoText variant="h6">{isCurrentlyAssigned ? shift?.assignedName : 'Unassigned'}</InfoText>
        </Box>
      </Box>
      {!disabled && <ArrowForwardIosIcon />}
    </AssignedButton>
  );
};

EmployeeAssignmentButton.propTypes = {
  onAssignClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default EmployeeAssignmentButton;
